import { getApi, putApi, postApi, deleteApi, getApiExcel } from 'apis';

const requestLoan = async (data: any) => {
	return await postApi('/loan', data);
};

const updateLoan = async (id: string, data: any) => {
	return await putApi(`/loan/update/${id}`, data);
};

const getLoanRequests = async (data: any) => {
	return await getApi('/loan', data);
};

const getLoanRequestDetails = async (id: any) => {
	return await getApi(`/loan/${id}`);
};

const updateLoanRequestStatus = async (id: string, data: any) => {
	return await putApi(`/loan/loanStatus/${id}`, data);
};

export const updateLoanRequest = async (id: string, data: any) => {
	return await putApi(`/loan/${id}`, data);
};

const deleteLoanRequest = async (id: any) => {
	return await deleteApi(`/loan/delete/${id}`);
};

const updateEffectiveDate = async (data: any) => {
	return await putApi(`/loan/creditLoan`, data);
};

const getLoanByEmployee = async (employeeId: string) => {
	return await getApi(`/loan/employee/${employeeId}`);
};

const getEmployeeDetailsForLoan = async (loanIds: string[]) => {
	return await postApi('/loan/employee-details', { loanIds });
};

const proceedToPaymentForFCB = async (data: any) => {
	return await postApi('/loan/initiate-payment', data);
};

const proceedToPaymentForStanbic = async (data: any) => {
	return await postApi('/loan/stanbic-initiate-payment', data);
};

const getBankDetailsForLoanDetails = async (data: { currency: string }) => {
	return await postApi('/loan/bank-details', data);
};

const downloadEmployeeLoanExcelWithTemplate = async (query:any) => {
	return await getApiExcel('/loan/all-loanEmployees-excel', query);
};

const getPaymentLogs = async (query: any) => {
	return await getApi('/loan/payment-logs', query);
};

const getAvailableDeductionsForLoan = async () => {
	return await getApi(`/loan/available-deductions`);
};

type SaveLoanPaymentConversionRatePayload = {
	loanIds: string[];
	conversionRate: number;
};

const saveConversionRate = async (data: SaveLoanPaymentConversionRatePayload) => {
	return await postApi('/loan/payment-conversion', data);
};

export const loanRequestApi = {
	getLoanRequests,
	getLoanRequestDetails,
	deleteLoanRequest,
	updateEffectiveDate,
	requestLoan,
	updateLoan,
	updateLoanRequestStatus,
	getLoanByEmployee,
	getEmployeeDetailsForLoan,
	proceedToPaymentForFCB,
	proceedToPaymentForStanbic,
	getBankDetailsForLoanDetails,
	downloadEmployeeLoanExcelWithTemplate,
	getPaymentLogs,
	getAvailableDeductionsForLoan,
	saveConversionRate,
};
